// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @30.07.2019 13:39:28
import { PhoneSession_abstract } from './../../abstract/SagaBase/Objects/PhoneSession_abstract';
export class PhoneSession extends PhoneSession_abstract {}
